module.exports = __webpack_public_path__ + "img/menu_bottom_6.8a7e25d7.svg";